import { endPoint } from "constants/server/api";
import { createFetchMaster } from "../../utils/fetchFactory";
import { createSlicePrototype } from "../../utils/sliceFactory";
var getAllMstAdjustOrFeeSlice = createSlicePrototype({
    name: "getAllMstAdjustOrFee"
});
export var getAllMstAdjustOrFee = createFetchMaster({
    actions: getAllMstAdjustOrFeeSlice.actions,
    config: {
        method: "get",
        url: endPoint.MST_ADJUST_OR_FEE
    }
});
var _getAllMstAdjustOrFeeSlice_actions = getAllMstAdjustOrFeeSlice.actions;
export var fetchData = _getAllMstAdjustOrFeeSlice_actions.fetchData, fetchDataSuccess = _getAllMstAdjustOrFeeSlice_actions.fetchDataSuccess, fetchDataFailure = _getAllMstAdjustOrFeeSlice_actions.fetchDataFailure, resetState = _getAllMstAdjustOrFeeSlice_actions.resetState;
export default getAllMstAdjustOrFeeSlice.reducer;
